module.exports = __webpack_public_path__ + "4bc77220c04ae2c12f17ca33aa58bd9d.pdf";